export const COOKIES_ANSWER_KEY = 'cookiesAnswer';

export const COOKIES_ACCEPT_KEY = 'accept';
export const COOKIES_DECLINE_KEY = 'decline';
